'use client';

import {useTranslations, useLocale} from 'next-intl';
import Button from '../ui/Button';

const parcours = [
  {key: 'discover', icon: '🏛️', href: '/a-propos', color: 'bg-white/15 hover:bg-white/25'},
  {key: 'find', icon: '🗺️', href: '/structures', color: 'bg-white/15 hover:bg-white/25'},
  {key: 'give', icon: '💚', href: '/don', color: 'bg-secondary/80 hover:bg-secondary'},
  {key: 'follow', icon: '📊', href: '/espace-donateur', color: 'bg-white/15 hover:bg-white/25'},
] as const;

const parcoursLabels: Record<string, Record<string, string>> = {
  discover: {fr: 'Decouvrir l\'UTSS', ar: 'اكتشف الاتحاد', en: 'Discover UTSS'},
  find: {fr: 'Trouver un projet', ar: 'ابحث عن مشروع', en: 'Find a project'},
  give: {fr: 'Faire un don', ar: 'تبرع', en: 'Donate'},
  follow: {fr: 'Suivre mon impact', ar: 'تتبع تأثيري', en: 'Track my impact'},
};

export default function HeroSection() {
  const t = useTranslations('home');
  const tc = useTranslations('common');
  const locale = useLocale();

  return (
    <section className="relative overflow-hidden">
      <div className="absolute inset-0 bg-primary-dark" aria-hidden="true" />
      <div className="absolute inset-0 bg-[url('/images/utss/article_12307437_900578810011357_7519468639371756778_o.jpg')] bg-cover bg-center" />
      <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/30" />

      <img
        src="/images/utss/rose.svg"
        alt=""
        aria-hidden="true"
        className="absolute right-4 lg:right-16 top-1/2 -translate-y-1/2 w-[300px] h-[300px] opacity-5 pointer-events-none select-none"
      />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 lg:py-32">
        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-2 bg-white/15 backdrop-blur-sm rounded-full px-4 py-2 mb-8">
            <img src="/images/utss/rose.svg" alt="" className="h-6 w-auto" />
            <span className="text-white/90 text-sm font-medium">
              {tc('since_1964')}
            </span>
          </div>

          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6">
            {t('hero_title')}
          </h1>
          <p className="text-lg text-white/80 mb-10 leading-relaxed max-w-2xl line-clamp-3">
            {t('hero_subtitle')}
          </p>

          {/* 4 parcours distincts — CDC 5.1 */}
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
            {parcours.map(({key, icon, href, color}) => (
              <a
                key={key}
                href={`/${locale}${href}`}
                className={`flex flex-col items-center gap-2 rounded-xl px-4 py-4 backdrop-blur-sm text-white transition-all ${color}`}
                style={{textDecorationColor: 'transparent'}}
              >
                <span className="text-2xl">{icon}</span>
                <span className="text-sm font-semibold text-center leading-tight">
                  {parcoursLabels[key]?.[locale] || parcoursLabels[key]?.fr}
                </span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
